module.exports = __webpack_public_path__ + "static/media/sidenav-licenses.d65c3531.svg";